import { RequestSetting } from 'src/interfaces';

export const getRefillRequestSettings = (requestSetting: RequestSetting) => {
  return {
    confirmationText: requestSetting.refillRequestConfirmationText,
    headerText: requestSetting.refillRequestHeaderText,
    requireComments: false,
    refillRequestsDisabled: requestSetting.refillRequestsDisabled
  };
};
